<template>
	<div>

		<div v-if="loading">
			Loading ...
		</div>
		<div v-else>

			<div class="margin-bottom border-bottom small-padding-bottom flex">
				<MaterialToggle v-model="reverse" label="Reverse" class="margin-right" />
				<MaterialToggle v-model="show_times" label="Intervals" />
				<MaterialToggle v-model="show_calls" label="Calls" />
				<MaterialToggle v-model="show_products" label="Products" />
				<MaterialToggle v-model="show_accounting" label="Accounting" />
			</div>

			<div class="order-history-events">
				<div v-for="(event, e) in events" class="order-history-event">

					<div v-if="show_times && timing(e).length" class="flex order-history-interval">
						<div class="parts">
							<div v-for="part in timing(e)" class="part">
								{{ part.number }} {{ part.unit }}
							</div>
						</div>
					</div>

					<div class="order-history-event-content">
						<div class="icon">
							<SvgIcon :name="getIcon(event)" />
						</div>
						<div>
							<div>{{ getDescription(event) }}</div>

							<div class="note">

								<Format type="date" :time="true" :value="event.date.date_time" />

								<template v-if="event.commit.by == 'system'">By system</template>
								<template v-else-if="event.commit.by == 'customer_service'">
									By {{ event.commit.internal_user.shortened_name }}
								</template>
								<template v-else-if="event.commit.by == 'customer'">
									By {{ event.commit.customer.full_name }} (customer)
								</template>
							</div>
						</div>
					</div>

				</div>
			</div>

		</div>

	</div>
</template>

<script>
import Vue from 'vue'

export default {
  props: [
    'id'
  ],
  data: () => ({
    data: {},
    loading: false,
    reverse: false,
    show_times: true,
    show_products: true,
    show_accounting: false,
    show_calls: true
  }),
  computed: {
    events () {
      var list = []

      if (this.data.events) {
        for (var event of this.data.events) {
          if (this.allow(event)) {
            list.push(event)
          }
        }
      }

      if (this.data.events_call) {
        for (var event1 of this.data.events_call) {
          if (this.allow(event1)) {
            list.push(event1)
          }
        }
      }

      console.log('Call events:', list)

      if (this.reverse) {
        return list.reverse()
      } else {
        return list
      }
    }
  },
  methods: {

    /**
			 * [allow description]
			 * @param  {[type]} event [description]
			 * @return {[type]}       [description]
			 */
    allow (event) {
      var productEvents = [
        'product:added',
        'product:removed',
        'product:returned'
      ]

      if (!this.show_products && productEvents.indexOf(event.event) >= 0) {
        return false
      }

      var accountingEvents = [
        'accounting:add-order-line',
        'accounting:remove-order-line',
        'accounting:return-order-line',
        'accounting:balanced',
        'accounting:balance-error-occurred',
        'accounting:dlv-delivered'
      ]

      if (!this.show_accounting && accountingEvents.indexOf(event.event) >= 0) {
        return false
      }

      var callEvents = [
        'call:booked',
        'call:transfered',
        'call:rescheduled',
        'call:cancelled'
      ]

      if (!this.show_calls && callEvents.indexOf(event.event) > -1) {
        return false
      }

      return true
    },

    getParams (event) {
      var list = []
      for (var i in event.parameters) {
        if (event.parameters[i] !== null && event.parameters[i].length > 0) {
          list.push(event.parameters[i])
        }
      }
      return list
    },

    /**
			 * [timing description]
			 * @param  {[type]} index [description]
			 * @return {[type]}       [description]
			 */
    timing (index) {
      if (index) {
        var last = new Date(this.events[index - 1].date.date_time).getTime()
        var current = new Date(this.events[index].date.date_time).getTime()
        var secondsLeft = Math.abs((last - current) / (1000))
        var factor = 1
        var list = []
        var definitions = [
          {
            divisor: 60,
            unit: ['min', 'mins']
          },
          {
            divisor: 60 * 60,
            unit: ['hr', 'hrs']
          },
          {
            divisor: 24 * 60 * 60,
            unit: ['day', 'days']
          }
        ].reverse()

        for (var d in definitions) {
          var definition = definitions[d]
          var number = Math.floor(secondsLeft / definition.divisor)

          secondsLeft -= number * definition.divisor

          if (number) {
            list.push({
              number: Math.round(number),
              unit: number == 1 ? definition.unit[0] : definition.unit[1],
              base_unit: definition.unit[0]
            })
          }
        }

        return list
          .filter(row => row.number > 0)
          .filter(row => row.base_unit != 'min' || row.number > 10)
          .splice(0, 2)
      }

      return false
    },
    load () {
      Vue.$api.get('/order/' + this.id + '/history', {}, {
        loader: toggle => this.loading = toggle,
        callback: data => this.parse(data)
      })
    },
    parse (data) {
      this.data = data
    },
    getIcon (event) {
      switch (event.event) {
        case 'cancelled':
        case 'shipment:delivered':
        case 'return:delivered':
        case 'return:parcelshop':
        case 'shipment:sorting':
        case 'shipment:parcelshop':
        case 'shipment:returned-to-sender':
          return 'shipment'
        case 'pin':
          return 'pin'
        case 'trial-period:expired':
          return 'datetime'
        case 'outbound:pushed':
          return 'outbound'
        case 'email:sent':
          return 'email'
        case 'return-order:synchronized':
          return 'return-order'
        case 'return-order:finalized':
          return 'return-finalize'
        case 'transaction:charge':
          return 'capture'
        case 'order:call':
          return 'call'
        case 'transaction:refund':
          return 'refund'
        case 'styling:finished':
          return 'styling-finished'
        case 'styling:begun':
          return 'styling-begun'
        case 'transaction:put-on-hold':
          return 'transaction-put-on-hold'
        case 'transaction:released-from-hold':
          return 'styling-begun'
        case 'transaction:delayed-until':
          return 'transaction-put-on-hold'
        case 'order:cloned':
        case 'order:cloned-to':
          return 'copy'
        case 'dlv:received':
          return 'dlv'
        case 'accounting:balanced':
          return 'accounting'
        case 'accounting:balance-error-occurred':
          return 'exclamation'
        case 'accounting:add-order-line':
          return 'add'
        case 'accounting:dlv-delivered':
          return 'synchronize'
        case 'accounting:remove-order-line':
          return 'subtract'
        case 'accounting:return-order-line':
          return 'return-order'
        case 'product:added':
          return 'add-product'
        case 'product:removed':
          return 'remove'
        case 'feedback:received':
          return 'rating'
        case 'debt-collection:cancelled':
          return 'delete'
        case 'debt-collection:settled':
          return 'done'
        case 'debt-collection:unsettled':
        case 'debt-collection:started':
          return 'debt-collection'
        case 'shipment:lost':
          return 'lost-shipment'
        case 'shipment:lost-changed-status':
          return 'exchange'
        case 'shipment:lost-resolved':
          return 'done'
        case 'webhook':
          return 'webhook'
        case 'exchange-request:created':
          return 'exchange'
        case 'exchange-request:deleted':
          return 'delete'
        case 'payment:entered-asynchronous-state':
          return 'async-state'
        case 'payment:closed-asynchronous-state':
          return event.parameters[1] == 'succeeded' ? 'done' : 'close-async-state'
        default:
          return 'info'
      }
    },
    getEventBase (event) {
      switch (event.event) {
        case 'shipment:lost':
          return (event.objects.shipment_tracking.type == 'return' ? 'Return' : 'Outbound') +
							' shipment with tracking number ' +
							event.objects.shipment_tracking.tracking.number +
							' reported lost'
        case 'shipment:lost-changed-status':
          return 'Lost shipment changed to status: [parameter_2]'
        case 'shipment:lost-resolved':
          return 'Lost shipment has been resolved'
        case 'debt-collection:cancelled':
          return 'Debt collection process has been cancelled/deleted on our side: "[parameter_1]"'
        case 'debt-collection:unsettled':
          return 'Debt collection process has been marked as un-settled'
        case 'debt-collection:settled':
          return 'Debt collection settled'
        case 'debt-collection:started':
          return 'Debt collection process started'
        case 'feedback:received':
          return 'Rated [parameter_1] / 5 with feedback: "[parameter_2]"'
        case 'dlv:received':
          return 'DLV file received'
        case 'order:cloned':
          return 'Order cloned from [parameter_1] (Environment: [parameter_2])'
        case 'order:cloned-to':
          return 'Used as source to clone order [parameter_1]'
        case 'transaction:delayed-until':
          return event.parameters[1]
            ? 'Delayed until [parameter_1]'
            : 'Unset delayed until'
        case 'rebuild':
          return '[parameter_1] partials rebuilt based on [parameter_2]'
        case 'cancelled':
          return this.getEventFormatedWithParams(event, 'Cancelled')
        case 'cleared':
          return this.getEventFormatedWithParams(event, 'Order cleared')
        case 'fulfilled':
          return 'Order fulfilled'
        case 'shipment:delivered':
          return 'Shipment picked up or delivered at the door'
        case 'return:delivered':
          return 'Return arrived at warehouse'
        case 'return:parcelshop':
          return 'Return handed in at parcelshop'
        case 'shipment:sorting':
          return 'Shipment is being sorted (distribution center)'
        case 'shipment:parcelshop':
          return 'Shipment delivered at parcelshop'
        case 'shipment:returned-to-sender':
          return 'Shipment returned to sender'
        case 'trial-period:expired':
          return 'Customer\'s time to try the clothes is up'
        case 'outbound:pushed':
          return 'Outbound pushed to warehouse'
        case 'order:call':
          return 'Call with customer'
        case 'text-message:sent':
          return 'Sent text message: "[parameter_1]"'
        case 'webhook':
          return 'Received webhook from [parameter_1]: [parameter_2]'
        case 'email:sent':
          return 'Sent email: [parameter_2] ([parameter_1])'
        case 'payment:changed-invoicing-days':
          return 'Gave customer [parameter_1] additional days to pay'
        case 'transaction:charge':
          return 'Charged [parameter_1] ([parameter_2])'
        case 'transaction:refund':
          return 'Refunded ' + Math.abs(event.parameters[1]) + ' ([parameter_2])'
        case 'return-order:synchronized':
          return 'Return order synchronized'
        case 'return-order:finalized':
          return 'Return order finalized'
        case 'comment':
          return 'Comment: "[parameter_1]"'
        case 'shipping:address-changed':
          return 'Shipping address changed to [parameter_1]'
        case 'shipping:parcelshop-changed':
          return 'Parcelshop changed to [parameter_1]'
        case 'styling:begun':
          return 'Styling begun'
        case 'styling:finished':
          return 'Styling finished'
        case 'payment:entered-asynchronous-state':
          return 'Entered asynchronous state'
        case 'payment:closed-asynchronous-state':
          switch (event.parameters[1]) {
            case 'succeeded':
              return 'Payment succeeded (exiting asynchronous state)'
            case 'failed':
              return 'Payment failed (exiting asynchronous state)'
            default:
              return 'Closed asynchronous state with unknown outcome'
          }
        case 'exchange-request:deleted':
          return 'Removed exchange request for ' + this.getProductName(event.objects)
        case 'exchange-request:created':
          return 'Placed exchange request for ' + this.getProductName(event.objects)
        case 'product:added':
        case 'product:removed':
          var word = event.event == 'product:added' ? 'Added' : 'Removed'

          return word + ' ' + this.getProductName(event.objects)
        case 'pin':
          return event.parameters[3]
            ? '[UNPINNED]: [parameter_1] ([parameter_2])'
            : 'Pinned: [parameter_1] ([parameter_2])'
        case 'transaction:put-on-hold':
          return 'Transaction put on hold'
        case 'transaction:released-from-hold':
          return 'Transaction released from hold'

        case 'accounting:add-order-line':
          return 'Order line added ([parameter_1])'
        case 'accounting:remove-order-line':
          return 'Order line removed ([parameter_1])'
        case 'accounting:return-order-line':
          return 'Order partials returned ([parameter_1])'
        case 'accounting:balanced':
          return 'Order Balanced'
        case 'accounting:balance-error-occurred':
          return 'Order Balance error occurred. ([parameter_1])'

        case 'accounting:dlv-delivered':
          return 'DLV delivered'

        case 'payment:plan-created':
          if (event.parameters[2]) {
            return 'Created payment plan with 2 rates with rate 1 to be paid on return finalised or [parameter_1] (whichever comes first) and [parameter_2] for rate 2'
          } else {
            return 'Created payment plan with 1 rate to be paid on [parameter_1]'
          }
        case 'call:booked':
          return 'Call booked for [parameter_2] (#[parameter_1])'
        case 'call:transfered':
          return 'Call transfered from ' +
							(event.objects.stylist[1].shortened_name) +
							' to ' +
							(event.objects.stylist[2].shortened_name)
        case 'call:rescheduled':
          return 'Rescheduled call from [parameter_2] to [parameter_3]'
        case 'call:cancelled':
          return 'Call cancelled (#[parameter_1])'
        default:
          return event.event
      }
    },
    getProductName (objects) {
      if (!objects) {
        return 'a product'
      } else if (objects.variant) {
        return objects.variant.sku
      } else if (objects.product) {
        return objects.product.sku
      } else {
        return 'a product'
      }
    },
    getDescription (event) {
      return this.getEventBase(event)
        .replace('[parameter_1]', event.parameters[1])
        .replace('[parameter_2]', event.parameters[2])
        .replace('[parameter_3]', event.parameters[3])
    },
    getEventFormatedWithParams (event, baseText) {
      baseText = event.parameters[1]
        ? baseText + ' ( [parameter_1] )'
        : baseText
      return event.parameters[2]
        ? baseText + ' ( [parameter_2])'
        : baseText
    }
  },
  created () {
    this.load()
  }
}
</script>

<style lang="less">
	.order-history-events {
		position: relative;
		&::after {
			top: 0px;
			bottom: 0px;
			left: @side-padding + 25px;
			width: 2px;
			background: #ddd;
			content: "";
			position: absolute;
		}
		@side-padding: 120px;
		.order-history-event {
			padding-left: @side-padding;
			.order-history-event-content {
				display: flex;
				align-items: center;
				margin-bottom: 20px;
				.icon {
					display: flex;
					align-items: center;
					justify-content: center;
					width: 50px;
					height: 50px;
					position: relative;
					margin-right: 15px;
					flex-grow: 0;
					flex-shrink: 0;
					.svg-icon, svg {
						position: relative;
						z-index: 150;
						width: 28px !important;
						height: 28px !important;
						fill: #888;
					}
					&::after {
						top: 0px;
						left: 0px;
						bottom: 0px;
						right: 0px;
						border: 2px solid #ddd;
						border-radius: 6px;
						position: absolute;
						content: "";
						z-index: 100;
						background: #fff;
					}
				}
			}
			.order-history-interval {
				position: relative;
				margin-top: -10px;
				margin-bottom: 10px;
				font-size: 14px;
				color: #999;
				left: -@side-padding;
				.parts {
					border-radius: 4px;
					z-index: 100;
					display: inline-flex;
					padding-right: 10px;
					background: #fff;
					.part {
						position: relative;
						margin-right: 10px;
						background: #fff;
						&:last-child {
							margin-right: 0px;
						}
					}
				}
				&::after {
					z-index: 50;
					position: absolute;
					left: 0px;
					top: 9px;
					height: 2px;
					background: #ddd;
					width: @side-padding + 25px;
					content: "";
				}
			}
		}
	}
</style>
